import { HttpClient } from '@angular/common/http';
import { ISettings } from '@lsq-frontend/angular-shared/settings';
import { ApiService } from './api-service';
import { ProtoRequest, ProtoResponse } from './models/request-response-all-java';

export abstract class ProtoApiService<
    TRequest extends ProtoRequest,
    TResponse extends ProtoResponse
> extends ApiService<TRequest, TResponse> {
    constructor(http: HttpClient, settings: ISettings) {
        super(http, settings);
    }
}
